import React, { useState, useEffect } from "react";
import { IoListSharp, IoSearch, IoCloudDownload } from "react-icons/io5";
import { HTTP } from "../../api/http-common";
import ErrorHandlingComponent from "../../components/ErrorHandlingComponent";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Loader from "../../components/loader";
import Pagination from "../../components/pagination";
import useUserRoleEffect from "../../components/userRoleEffect";
import withReactContent from "sweetalert2-react-content";
import ParticipationListUI from "../../components/ParticipationListUI";
import { CommonTitle } from "../../components/commonComponents";

export default function Participation() {
  const access_token = localStorage.getItem("access_token");
  const userObj = JSON.parse(localStorage.getItem("userObj"));
  const [error, setError] = useState(null);
  const [rerenderFlag, setRerenderFlag] = useState(false);
  // const [search, setSearch] = useState({
  //   name: "",
  //   selection_status_id: null,
  //   aa_master_id: "2",
  //   temp_status_id: null,
  //   temp_points: "",
  // });
  const defaultFilters = {
    name: "",
    selection_status_id: null,
    aa_master_id: "2",
    temp_status_id: null,
    temp_points: "",
    category: "",
  };
  const [search, setSearch] = useState(() => {
    const storedFilters = localStorage.getItem("participationFilters");
    return storedFilters ? JSON.parse(storedFilters) : defaultFilters;
  });

  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({ page: "1", limit: "10" });
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState(() => {
    return localStorage.getItem("searchValue") || "";
  });
  const [participations, setParticipations] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [aaMasters, setAaMasters] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [selectionCount, setSlectionCount] = useState(0);
  const [selectedStatusCount, setSelectedStatusCount] = useState(0);
  const [rejectedStatusCount, setRejectedStatusCount] = useState(0);
  const [waitiongStatusCount, setWaitingStatusCount] = useState(0);
  const MySwal = withReactContent(Swal);

  const userRole = userObj?.role?.id;
  useUserRoleEffect(userRole);

  const loadParticipations = async () => {
    setIsLoading(true);
    let config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    let fields = {
      // filters: {
      //   name: search.name,
      //   selection_status_id: search.selection_status_id,
      //   aa_master_id: search.aa_master_id,
      //   temp_status_id: search.temp_status_id,
      //   temp_points: search.temp_points,
      //   category: search.category,
      // },
      filters: { ...search },
      pagination: pagination,
      sorting: { field: "id", type: "desc" },
    };
    HTTP.post("amazing_adanians/participation/list", fields, config)
      .then((response) => {
        const data = response.data;
        if (response.status === 200) {
          setParticipations(data.contents);
          const participantIds = data.contents.map(
            (participation) => participation.id
          );
          setParticipants(participantIds);
          setTotal(data.total_count);
        }
        if (response.status === 204) {
          setParticipations([]);
        }
      })
      .catch((error) => {
        setError(error);
        setRerenderFlag(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleResetFilters = () => {
    setSearch(defaultFilters);
    localStorage.removeItem("participationFilters");
    localStorage.removeItem("searchValue");
    setSearchValue("");
  };

  const loadStatuses = async () => {
    let config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    let fields = {
      filters: {
        name: "",
      },
      sorting: { field: "order_index", type: "asc" },
    };
    HTTP.post("amazing_adanians/selection/status/list", fields, config)
      .then((response) => {
        if (response.status === 200) {
          setStatuses(response.data);
        }
        if (response.status === 204) {
          Swal.fire("", "Selection Statuses Not Found", "error");
        }
      })
      .catch((error) => {
        setError(error);
        setRerenderFlag(true);
      });
  };

  const loadUserData = async () => {
    let config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    HTTP.get("user/" + userObj.id, config)
      .then((response) => {
        if (response.status === 200) {
          setSlectionCount(response.data.content.selection_count);
        }
        if (response.status === 204) {
          Swal.fire("", "User Not Found", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadAaMaster = async () => {
    let config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    let fields = {
      filters: { name: "" },
      pagination: {},
      sorting: { field: "id", type: "asc" },
    };
    HTTP.post("/amazing_adanians/master/list", fields, config)
      .then((response) => {
        if (response.status === 200) {
          setAaMasters(response.data);
        }
        if (response.status === 204) {
          Swal.fire("", "Amazing Adanians master Not Found", "error");
        }
      })
      .catch((error) => {
        setError(error);
      });
  };

  const calculateSubmissionStatus = async () => {
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    HTTP.post("amazing_adanians/participation/judge/ppstatus/count", {}, config)
      .then((response) => {
        setWaitingStatusCount(response.data.content.wfr);
        setSelectedStatusCount(response.data.content.selected);
        setRejectedStatusCount(response.data.content.rejected);
      })
      .catch((error) => {
        // Handle error if needed.
      });
  };

  // Export function to call export API and download CSV file.
  const exportData = async () => {
    const config = {
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        token: access_token,
      },
      responseType: "blob", // Important for binary files like Excel
    };
    const fields = {
      filters: {
        name: search.name,
        selection_status_id: search.selection_status_id,
        aa_master_id: search.aa_master_id,
        temp_status_id: search.temp_status_id,
        temp_points: search.temp_points,
        category: search.category,
      },
      pagination: {},
      sorting: { field: "id", type: "desc" },
    };

    try {
      const response = await HTTP.post(
        "amazing_adanians/participation/export",
        fields,
        config
      );

      // Create a blob for Excel file
      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "participations_export.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      Swal.fire("", "Export failed", "error");
    }
  };

  const handleFinalSubmission = () => {
    MySwal.fire({
      title: "Are you sure you want final submission?",
      text: "After final submission you can not update status of any participants",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        if (selectionCount === selectedStatusCount) {
          setIsLoading(true);
          let config = {
            headers: { "Content-Type": "application/json", token: access_token },
          };
          let fields = {
            participation_ids: participants,
          };
          HTTP.put(
            "/amazing_adanians/participation/final_submission",
            fields,
            config
          )
            .then((response) => {
              if (response.status === 200) {
                Swal.fire("", response.data.message, "success");
              }
            })
            .catch((error) => {
              setError(error);
              setRerenderFlag(true);
            })
            .finally(() => {
              setIsLoading(false);
            });
        } else {
          let message = "<p><strong>You Selected</strong></p>";
          message += `<p><strong>Waiting for review:</strong> ${waitiongStatusCount}</p>`;
          message += `<p><strong>Selected:</strong> ${selectedStatusCount}</p>`;
          message += `<p><strong>Rejected:</strong> ${rejectedStatusCount}</p>`;

          Swal.fire({
            title: `Required selected participants ${selectionCount}`,
            html: message,
            icon: "error",
          });
        }
      }
    });
  };
  useEffect(() => {
    localStorage.setItem("participationFilters", JSON.stringify(search));
  }, [search]);

  useEffect(() => {
    loadParticipations();
    if (rerenderFlag) {
      setRerenderFlag(false);
    }
  }, [rerenderFlag, search, pagination]);

  useEffect(() => {
    calculateSubmissionStatus();
  }, [participations]);

  // useEffect(() => {
  //   loadParticipations();
  //   if (rerenderFlag) {
  //     setRerenderFlag(false);
  //   }
  // }, [rerenderFlag, search, pagination]);

  useEffect(() => {
    calculateSubmissionStatus();
  }, [participations]);

  const onPaginationChange = (page) => {
    setPagination({ ...pagination, page });
  };

  const onLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setPagination({ ...pagination, limit: newLimit, page: 1 });
  };

  const onSearchEnter = (value) => {
    if (value.length === 0 || value.length >= 3) {
      setSearch({ ...search, name: value });
      setPagination({ ...pagination, page: 1, limit: pagination.limit });
    }
  };

  useEffect(() => {
    localStorage.setItem("searchValue", searchValue);
  }, [searchValue]);

  const handleStatusChange = (selection_status_id) => {
    if (participations.is_final_submission_done) {
      setSearch({ ...search, selection_status_id: selection_status_id });
    } else {
      setSearch({ ...search, temp_status_id: selection_status_id });
    }
  };

  const handlePointsChange = (value) => {
    setSearch({ ...search, temp_points: value });
  };
  const handleCategoryChange = (value) => {
    setSearch({ ...search, category: value });
  };

  const handleAaMasterChange = (value) => {
    setSearch({ ...search, aa_master_id: value });
  };

  useEffect(() => {
    loadStatuses();
    loadAaMaster();
  }, []);

  useEffect(() => {
    if (userRole === 6) {
      loadUserData();
    }
  }, [search.aa_master_id]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="article-wrapper">
      {rerenderFlag && <ErrorHandlingComponent err={error} />}
      {userRole === 6 && (
        <span className="participation-header">
          <CommonTitle PageTitle="Participation List" />
          <p>
            Required Selected Participant: {selectionCount} : Play video for at
            least 5 seconds.
          </p>
        </span>
      )}
      <div className="video-table-wrapper">
        <div className="action-buttons-wrapper row">
          <div className="left-button col-lg-6 col-md-3 col-6">
            <button
              className="video-table-button-structure bg-secondary"
              style={{ padding: "9px 25px" }}
            >
              <span>
                <span className="video-page-icons">
                  {" "}
                  <IoListSharp />
                </span>
                <span>List </span>
              </span>
            </button>
          </div>
          <div className="right-button col-lg-6 col-md-9 col-6">
            <ul className="action-buttons">
              <button
                onClick={handleResetFilters}
                className="btn btn-secondary video-table-button-structure me-2"
              >
                Reset Filters
              </button>
              {userRole === 1 && (
                <>
                  {/* <li className='p-0'> */}
                  {/* <div className=""> */}
                    <button
                      className="video-table-button-structure bg-blue"
                      style={{ padding: "7px 25px" }}
                      onClick={exportData}
                    >
                      <span className="video-page-icons">
                        {" "}
                        <IoCloudDownload />
                      </span>
                      <span>Export</span>
                    </button>
                  {/* </div> */}
                  {/* </li> */}
                </>
              )}
              {/* <li className='p-0'> */}
              {userRole === 6 && (
                <>
                  <div className="col-lg-4 col-md-3 col-6">
                    <span className="action-buttons">
                      {participations.some(
                        (participation) =>
                          participation.is_final_submission_done
                      ) ? (
                        <a
                          className="final-submission-button video-table-button-structure bg-blue"
                          disabled
                        >
                          Final Submission
                        </a>
                      ) : (
                        <a
                          className="final-submission-button video-table-button-structure bg-blue"
                          onClick={handleFinalSubmission}
                        >
                          Final Submission
                        </a>
                      )}
                    </span>
                  </div>
                </>
              )}
              {/* </li> */}
            </ul>
          </div>
        </div>
        <div className="video-table-main">
          <div className="timeline-actions-wrapper row justify-content-between align-items-center">
            <div className="col-xl-3 col-lg-5 col-md-6">
              <span className="d-flex border border-secondary p-1 border-radius align-items-center">
                <span>
                  <IoSearch />
                </span>
                <span className="viewer-searchfield">
                  <input
                    type="text"
                    placeholder="Search and press enter"
                    className="border-0 inner-searchbar"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        onSearchEnter(e.target.value);
                      }
                    }}
                  />
                </span>
              </span>
            </div>

            <div className="col-xl-9 col-lg-6 col-md-6 d-flex align-items-center  video-table-dropdown p-0">
              <div className="row w-100 align-items-center">
                <div className="col-lg-3 pe-0">
                  <div className="d-flex align-items-center">
                    <label htmlFor="categorySelect" className="pe-2 mb-0">
                      {" "}
                      Category:
                    </label>
                    <select
                      name="category"
                      id="pointsSelect"
                      className="border-secondary custom-filter-dropdown-size p-1  form-input "
                      onChange={(e) => {
                        handleCategoryChange(e.target.value);
                      }}
                      value={
                        participations.is_final_submissoin_done
                          ? search.category
                          : search.category
                      }
                    >
                      <option key="" value="">
                        All
                      </option>
                      <option key="Singing" value="Singing">
                        Singing
                      </option>
                      <option key="Dancing" value="Dancing">
                        Dancing
                      </option>
                      <option
                        key="Musical Instruments"
                        value="Musical Instruments"
                      >
                        Musical Instruments
                      </option>
                      <option key="Others" value="Others">
                        Others
                      </option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-3 pe-0">
                  <div className="d-flex align-items-center">
                    <label htmlFor="pointsSelect" className="pe-2 mb-0">
                      {" "}
                      Points:
                    </label>
                    <select
                      name="temp_points"
                      id="pointsSelect"
                      className="border-secondary custom-filter-dropdown-size p-1  form-input "
                      onChange={(e) => {
                        handlePointsChange(e.target.value);
                      }}
                      value={
                        participations.is_final_submissoin_done
                          ? search.temp_points
                          : search.temp_points
                      }
                    >
                      <option key="" value="">
                        All
                      </option>
                      <option key="points_given" value="points_given">
                        Points Given
                      </option>
                      <option key="points_pending" value="points_pending">
                        Points Pending
                      </option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="d-flex align-items-center">
                    <label htmlFor="statusSelect" className="pe-2 mb-0">
                      {" "}
                      Status:
                    </label>
                    <select
                      name="status"
                      id="statusSelect"
                      className="border-secondary custom-filter-dropdown-size p-1  form-input "
                      onChange={(e) => {
                        handleStatusChange(e.target.value);
                      }}
                      value={
                        participations.is_final_submissoin_done
                          ? search.selection_status_id
                          : search.temp_status_id
                      }
                    >
                      <option key="" value="">
                        All
                      </option>
                      {Array.isArray(statuses) &&
                        statuses.length > 0 &&
                        statuses.map((status) => (
                          <option key={status.id} value={status.id}>
                            {status.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-3 px-0">
                  <div className="d-flex align-items-center">
                    <label htmlFor="aaMaster" className="pe-2 no-wrap mb-0">
                      {" "}
                      Season:
                    </label>
                    <select
                      name="aaMaster"
                      id="aaMaster"
                      className="border-secondary custom-filter-dropdown-size p-1  form-input "
                      onChange={(e) => {
                        handleAaMasterChange(e.target.value);
                      }}
                      value={search.aa_master_id}
                    >
                      <option key="" value="">
                        All
                      </option>
                      {Array.isArray(aaMasters.contents) &&
                        aaMasters.contents.length > 0 &&
                        aaMasters.contents.map((aaMaster) => (
                          <option key={aaMaster.id} value={String(aaMaster.id)}>
                            {aaMaster.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {Array.isArray(participations) && participations.length > 0 ? (
            participations.map((participation) => (
              <ParticipationListUI
                key={participation.id}
                participation={participation}
                statusList={statuses}
                handleReload={loadParticipations}
              />
            ))
          ) : (
            <p className="text-center mt-4">No participant found</p>
          )}
        </div>
        <div>
          {Array.isArray(participations) && participations.length > 0 && (
            <Pagination
              total={total}
              pagination={pagination}
              handlePageChange={onPaginationChange}
              handleLimitChange={onLimitChange}
            />
          )}
        </div>
      </div>
    </div>
  );
}